import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
    ContractIcon,
    // HistoryIcon, (MERP-551)
    MemberIcon,
    TeamIcon,
} from '@/assets/icons/icons.jsx'
import Sidebar from '@/components/sidebar/Sidebar.jsx'
import Tabs from '@/components/tabs/Tabs.jsx'
import { setPanelId, selectPanelId } from '@/services/settings/settingsSlice'
import { LABELS_TABLES } from '@/utilities/constants/commons'

import ContractsSidebar from './contracts/ContractsSidebar'
// import MemberHistorySidebar from './history/MemberHistorySidebar' (MERP-551)
import MemberSidebar from './member/MemberSidebar'
import MemberTeamHistorySidebar from './member-team-history/MemberTeamHistorySidebar'

const MemberSidebarWrapper = ({ setOpenForm }) => {
    const dispatch = useDispatch()
    const panelId = useSelector(selectPanelId)

    const { t } = useTranslation()
    const [tabValue, setTabValue] = useState(LABELS_TABLES.member)

    const sideBarMemberData = [
        {
            id: 1,
            value: LABELS_TABLES.member,
            label: t('settings.sidebar_left.tabs.member'),
            icon: <MemberIcon />,
            component: <MemberSidebar setOpenForm={setOpenForm} />,
        },
        {
            id: 2,
            value: LABELS_TABLES.contracts,
            label: LABELS_TABLES.contracts,
            icon: <ContractIcon />,
            component: (
                <ContractsSidebar setOpenForm={setOpenForm} panelId={panelId} />
            ),
        },
        {
            id: 3,
            value: LABELS_TABLES.team,
            label: LABELS_TABLES.team,
            icon: <TeamIcon />,
            component: (
                <MemberTeamHistorySidebar
                    setOpenForm={setOpenForm}
                    panelId={panelId}
                />
            ),
        },
        // TODO: comment until further notice (MERP-551)
        // {
        //     id: 4,
        //     value: LABELS_TABLES.history,
        //     label: LABELS_TABLES.history,
        //     icon: <HistoryIcon />,
        //     component: <MemberHistorySidebar />,
        // },
    ]

    return (
        <Sidebar
            openIcon={false}
            onClose={() => {
                dispatch(setPanelId(undefined))
                setTabValue(LABELS_TABLES.member)
            }}
            open={panelId !== undefined}
        >
            <Tabs
                defaultValue={tabValue}
                triggers={sideBarMemberData}
                isSidePanel={true}
                haveDivider
                onValueChange={e => setTabValue(e)}
            />
        </Sidebar>
    )
}

export default MemberSidebarWrapper

MemberSidebarWrapper.propTypes = {
    setOpenForm: PropTypes.func,
}
